<h2 mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <div *ngIf="layers.length > 0" class="upload-layer-container" [formGroup]="newFeatureLayerForm">
    <mat-label class="p-2">{{ layers.length }} layer results. Select the layers you would like to add as an ArcGIS Feature layer</mat-label>
    <div class="upload-layer-content">
      <div *ngFor="let layer of layers; let i = index" class="info-row">
        <mat-checkbox id="{{ layer.name }}" class="checkbox-padding" (change)="changeCheckLayer($event.checked, layer)">
          <span class="layer-name-label">{{ layer.name }}</span>
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="anyChecked()" class="d-flex mt-2 g-2">
      <div class="flex-grow-1">
        <mat-form-field class="form-slim">
          <input matInput placeholder="New Layer Name" formControlName="newFeatureLayerName" id="newFeatureLayerName" type="text" maxlength="18" />
        </mat-form-field>
      </div>
      <div class="flex-grow-1 d-flex align-items-center g-1">
        <span>Opacity:</span>
        <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
          <input matSliderThumb formControlName="newFeatureLayerOpacity">
        </mat-slider>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button
    matButton="filled" color="primary"
    id="btnAdd"
    [mat-dialog-close]="true"
    [disabled]="!anyChecked()"
    (click)="addArcGISFeatureLayers()">
    Add
  </button>
</mat-dialog-actions>
